import { CapoPlugin } from "/var/www/mj_client/releases/20251113081132/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];